import script from "./RelationProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./RelationProfile.vue?vue&type=script&setup=true&lang=js"

import "./RelationProfile.vue?vue&type=style&index=0&id=deb66d1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-deb66d1e"]])

export default __exports__